import {TodoTrackerDetailRes} from "./tracker/todo-tracker";
import {UserDetailsRes} from '../cp';
import {Type} from 'class-transformer';

export class TodoDetailRes {
    id!: number;
    task!: string;
    description!: string;
    doneAt!: string;
    @Type(() => UserDetailsRes)
    owner!: UserDetailsRes;
}

export class ObserverRes {
    id!: number;
    @Type(() => UserDetailsRes)
    user!: UserDetailsRes;
    isOwner!: boolean;
}

export class ToDoCreateReq {
    task!: string;
    description!: string;
    groupId!: number;
}

export class ObserverCreateReq {
    isOwner: boolean = false;
    userId!: number;

    constructor(user: UserDetailsRes) {
        this.userId = user.id;
        this.isOwner = false;
    }
}

export class ToDoGroupRes {
    id!: number;
    name!: string;
    @Type(() => ObserverRes)
    observer: ObserverRes[] = [];
    @Type(() => TodoTrackerDetailRes)
    parts: TodoTrackerDetailRes[] = [];

    get owner() {
        return this.observer.find(x => x.isOwner)
    }
}

export class ToDoGroupCreateReq {
    name!: string;
    observer: ObserverCreateReq[] = [];
}

